"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LoadingPage;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Image_1 = __importDefault(require("../Image"));
const Text_1 = __importDefault(require("../Text"));
const variables_1 = __importDefault(require("../../styles/variables"));
const Center_1 = __importDefault(require("../Center"));
const useStyles = (0, core_1.makeStyles)({
    grid: {
        height: '90vh',
    },
    image: {
        width: '30vw',
        height: '30vh',
    },
    progress: {
        marginTop: '80px',
        width: '35vw',
        backgroundColor: variables_1.default.colors.surface.neutral.default,
        height: '8px',
        borderRadius: variables_1.default.spacing(1),
    },
    progressBar: {
        backgroundColor: variables_1.default.colors.action.primary.default,
    },
    loadingMessage: {
        marginTop: '2rem',
        fontWeight: 500,
        letterSpacing: '0.0005em',
    },
});
function LoadingPage({ message, logoImageUrl = 'https://alcumusstaticcontent.z13.web.core.windows.net/ecompliance-logo-ecoonline.svg', }) {
    const classes = useStyles();
    return (react_1.default.createElement(core_1.Grid, { container: true, direction: "column", justifyContent: "center", alignItems: "center", className: classes.grid },
        react_1.default.createElement(Image_1.default, { src: logoImageUrl, alt: "logo", className: classes.image, "data-testid": "alcumusLogo" }),
        react_1.default.createElement(core_1.LinearProgress, { variant: "indeterminate", className: classes.progress, classes: {
                bar1Indeterminate: classes.progressBar,
                bar2Indeterminate: classes.progressBar,
            }, "data-testid": "alcumusProgressBar" }),
        !!message?.length && (react_1.default.createElement(Center_1.default, null,
            react_1.default.createElement(Text_1.default, { as: "p", className: classes.loadingMessage }, message)))));
}
